import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { clearPendingLoginCredentials, setGameEntryActionPending, thunkLoginManual } from '../../redux/actions/gameEntryActions';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { YELLOW_COLOR } from '../../styles/colors';
import { OpenModalContainer } from '../openModalContainer';
import { RefreshButton } from '../refreshButton';
import { TimeDelayButton } from '../timeDelayButton';
const WARNING_MESSAGE_CSS = css `
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  color: ${YELLOW_COLOR};
`;
export const OutdatedClientModal = ({ isLoginConfirmation, onClose }) => {
    const pendingLoginCredentials = useAppSelector((state) => state.gameEntry.pendingLoginCredentials);
    const socketSend = useSocketSend();
    const dispatch = useAppDispatch();
    const onClickLoginAnyway = useCallback(() => {
        onClose();
        if (!isLoginConfirmation) {
            dispatch(addMessageBox({ type: 'outdated-client', isLoginConfirmation: true }));
        }
        else {
            // attempt login now, if pending credentials are set
            if (pendingLoginCredentials) {
                const { username, password } = pendingLoginCredentials;
                dispatch(thunkLoginManual({ socketSend, username, password, skipReverifyCheck: false }));
                dispatch(clearPendingLoginCredentials());
            }
            else {
                dispatch(setGameEntryActionPending(false));
            }
        }
    }, [dispatch, isLoginConfirmation, onClose, pendingLoginCredentials, socketSend]);
    const title = isLoginConfirmation ? 'Really log in with an outdated client?' : 'Outdated Client';
    const message = isLoginConfirmation ? (_jsxs(_Fragment, { children: [_jsxs("div", { css: WARNING_MESSAGE_CSS, children: [_jsx(WarningRoundedIcon, { style: { display: 'inline', verticalAlign: 'bottom' } }), " You can log in with an outdated client, but things may be broken or crash!"] }), _jsxs("div", { children: ["Click Refresh ", isMobile ? '(or force close and reopen) ' : '', "to update your client version."] })] })) : (`Your client appears to be outdated. Click Refresh ${isMobile ? '(or force close and reopen) ' : ''}to get the latest version.`);
    return (_jsxs(OpenModalContainer, { title: title, children: [_jsx(DialogContent, { children: _jsx(DialogContentText, { component: 'div', children: message }) }), _jsxs(DialogActions, { children: [_jsx(RefreshButton, { type: 'labeled' }), _jsx(TimeDelayButton
                    // specify a key to force the timer to restart when switching to the confirmation message:
                    , { disabledLabel: 'Login Anyway', enabledLabel: 'Login Anyway', ariaLabel: 'confirm button', variant: 'outlined', color: 'secondary', numSeconds: 3, onClick: onClickLoginAnyway }, isLoginConfirmation ? 'confirmation-button' : 'initial-button')] })] }));
};
